/*
  Milo: shows the right variant data in the Milo PDP sections.
  Every variant-dependent value is rendered server-side for all variants
  (so search engines and AI agents can read them) and marked with
  data-milo-variant="<variant id>". This script shows the values of the
  selected variant and hides the rest.
*/
(function () {
  if (window.miloVariantSync) return;
  window.miloVariantSync = true;

  function currentVariantId() {
    var fromUrl = new URL(window.location.href).searchParams.get('variant');
    if (fromUrl) return fromUrl;
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? input.value : null;
  }

  var last = null;
  function apply() {
    var id = currentVariantId();
    if (!id || id === last) return;
    var nodes = document.querySelectorAll('[data-milo-variant]');
    var has = false;
    nodes.forEach(function (el) { if (el.getAttribute('data-milo-variant') === String(id)) has = true; });
    if (!has) return; // unknown id: keep what the server rendered
    last = id;
    nodes.forEach(function (el) {
      el.hidden = el.getAttribute('data-milo-variant') !== String(id);
    });
  }

  // The theme updates ?variant= in the URL when a customer picks a variant.
  ['pushState', 'replaceState'].forEach(function (name) {
    var original = history[name];
    history[name] = function () {
      var result = original.apply(this, arguments);
      setTimeout(apply, 0);
      return result;
    };
  });
  window.addEventListener('popstate', apply);
  // Fallback: any change in the product form (variant buttons or dropdown).
  document.addEventListener('change', function () { setTimeout(apply, 60); });
  document.addEventListener('DOMContentLoaded', apply);
  apply();
})();
